/* *****************************************************************************
 * NOTE: this module is lifted from spinnaker/deck so that Tags functionality
 *       can be overriden. At the time of the 2.26 release this module correctly
 *       saved tags, but you were unable to use those tags. In order to prevent
 *       confusion amongst users, we are disabling this until further notice.
 *       Contact the PUX team in #eng-platform-ux if you're curious to know more.
 * *****************************************************************************
 */
import React from 'react';
import { module } from 'angular';

import {
  FormField,
  TextAreaInput,
  OverrideRegistry,
  IPipeline,
} from '@spinnaker/core';

export interface IMetadataPageContentProps {
  pipeline: IPipeline;
  updatePipelineConfig: (changes: Partial<IPipeline>) => void;
}

export function MetadataPage(props: IMetadataPageContentProps) {
  const { pipeline, updatePipelineConfig } = props;

  return (
    <FormField
      name="description"
      label="Description"
      value={pipeline.description}
      onChange={(e) => updatePipelineConfig({ description: e.target.value })}
      input={(inputProps) => (
        <TextAreaInput
          {...inputProps}
          placeholder={
            '(Optional) anything that might be helpful to explain the purpose of this pipeline; Markdown is okay'
          }
          rows={3}
        />
      )}
    />
  );
}

export class MetadataPageContent extends React.Component<IMetadataPageContentProps, {}> {
  public render(): React.ReactElement<typeof MetadataPage> {
    return (<MetadataPage {...this.props} />);
  }
}

export const ARMORY_PIPELINE_METADATA_MODULE = 'armory.pipeline.metadata.v1'
module(ARMORY_PIPELINE_METADATA_MODULE, [])
  .run(function (overrideRegistry: OverrideRegistry) {
    overrideRegistry.overrideComponent('metadataPageContent', MetadataPageContent)
  });
